import { useEffect } from 'react';
import { iFrameMessageTypes } from '../../types/iFrameMessageTypes';

const useIframeListener = (messageType: iFrameMessageTypes, returnOnlyData: boolean, callback: Function) => {
  useEffect(() => {
    const handler = (event: MessageEvent) => {
      let iframeIsTrusted = false;
      const trustedStartsWith = import.meta.env.VITE_TRUSTED_IFRAME_DOMAIN;
      if (trustedStartsWith) {
        for (let i = 0; i <= trustedStartsWith?.length; i++) {
          if (event.origin.startsWith(trustedStartsWith[i])) iframeIsTrusted = true;
        }
      }

      if (iframeIsTrusted) {
        const msgType = event.data.event;

        if (msgType && msgType.toUpperCase() === messageType.toUpperCase()) {
          if (returnOnlyData) callback(event.data.value);
          else callback(event);
        }
      }
    };

    window.removeEventListener('message', handler);
    window.addEventListener('message', handler);

    // clean up
    return () => {
      window.removeEventListener('message', handler);
    };
  }, [callback, messageType, returnOnlyData]);
};

export default useIframeListener;
